import Repair from '@/models/Repair/Repair';

export default class RepairFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.controlCardId  = '';
		this.controlCardControlCardNumber = '';
		this.controlCardNumber = '';
		this.partId = '';
		this.caseQty = '';
		this.caseQtyFrom = '';
		this.caseQtyTo = '';
		this.qtyOk = '';
		this.qtyOkFrom = '';
		this.qtyOkTo = '';
		this.qtyNg = '';
		this.qtyNgFrom = '';
		this.qtyNgTo = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			controlCardId : '0',
			controlCardControlCardNumber : '0',
			controlCardNumber : '0',
			partId : '0',
			caseQty : '0',
			caseQtyFrom : '0',
			caseQtyTo : '0',
			qtyOk : '0',
			qtyOkFrom : '0',
			qtyOkTo : '0',
			qtyNg : '0',
			qtyNgFrom : '0',
			qtyNgTo : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}